import { cloneDeep } from "lodash";

export const DownloadDialogController = ($scope,
                                         $mdDialog,
                                         callback,
                                         id,
                                         minDate,
                                         maxDate,
                                         rules) => {
    "ngInject";
    $scope.callback = callback;
    $scope.minDate = minDate;
    $scope.maxDate = maxDate;
    $scope.rules = rules;
    $scope.dateRange = {
        start: cloneDeep(minDate),
        end: cloneDeep(maxDate)
    };
    $scope.downloadObj = {
        deployment: id,
        remove_bg: false,
        outputTypes: {
            printing: true,
            sharing: true,
            original: true,
            remove_bg: false
        },
        captureModes: {
            photo: true,
            gif: true,
            boomerang: true,
            video: true
        }
    };

    $scope.closeDialog = () => {
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    $scope.create = () => {
        let date = "";
        if (minDate && maxDate) {
            date = `?start_date=${moment($scope.dateRange.start).utc().format("YYYY-MM-DD HH:mm:SS")}&end_date=${moment($scope.dateRange.end).utc().format("YYYY-MM-DD HH:mm:SS")}`;
        }
        if ($scope.downloadObj.outputTypes.remove_bg) {
            $scope.downloadObj.remove_bg = true;
        }else{
            $scope.downloadObj.remove_bg = false;
        }
        callback({data: $scope.downloadObj, timeRange: date});
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    $scope.checkOptions = (option) => {
        if (option === "photo") {
            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.boomerang && !$scope.downloadObj.captureModes.video) {
                $scope.downloadObj.captureModes.photo = true;
            }
        }

        if (option === "gif") {
            if (!$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.boomerang && !$scope.downloadObj.captureModes.video) {
                $scope.downloadObj.captureModes.gif = true;
            }
        }

        if (option === "boomerang") {
            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.video) {
                $scope.downloadObj.captureModes.boomerang = true;
            }
        }

        if (option === "video") {
            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.boomerang) {
                $scope.downloadObj.captureModes.video = true;
            }
        }
    };

    $scope.checkOutputs = (option) => {
        if (option === "printing") {
            if (!$scope.downloadObj.outputTypes.original && !$scope.downloadObj.outputTypes.sharing) {
                $scope.downloadObj.outputTypes.printing = true;
            }
        }

        if (option === "sharing") {
            if (!$scope.downloadObj.outputTypes.original && !$scope.downloadObj.outputTypes.printing) {
                $scope.downloadObj.outputTypes.sharing = true;
            }
        }

        if (option === "original") {
            if (!$scope.downloadObj.outputTypes.sharing && !$scope.downloadObj.outputTypes.printing) {
                $scope.downloadObj.outputTypes.original = true;
            }
        }
        if (option === "remove_bg") {
            $scope.downloadObj.outputTypes.printing = false;
            $scope.downloadObj.outputTypes.sharing = false;
            $scope.downloadObj.outputTypes.original = false;
        }
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            $scope.create();
        }
    };
};



// WEBPACK FOOTER //
// ./sources/components/media/download-dialog/download-dialog.js